<div class="split-container">
  <!-- BRANDING PANE (Left/Top) -->
  <div class="brand-pane">
    <div class="brand-header">
      <div class="logo-area">
        <img class="logo-img" src="assets/images/aims-logo.svg" />
      </div>
    </div>

    <div class="brand-content">
      <h1 class="brand-heading">
        {{ translator("password-reset-title") }}
      </h1>
      <p class="brand-subtext">
        {{ translator("password-reset-text") }}
        <br />
        {{ translator("password-reset-text-1") }}
      </p>
      <p class="brand-subtext">
        {{ translator("password-reset-text-2") }}
      </p>
    </div>

    <div class="brand-footer">
      <img
        class="image-prowred-by"
        src="assets/images/poweredbywissenswerft.svg"
      />
      <p class="imprint-text">
        {{ translator("password-imprint-text") }}
      </p>
    </div>
  </div>

  <!-- FORM PANE (Right/Bottom) -->
  <div class="form-pane">
    <div class="form-card">
      @if (isSuccess()) {
        <!-- Success State -->
        <div class="success-message fade-in">
          <div class="success-icon-circle">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <h2 class="form-title" style="color: #166534; margin-bottom: 1rem">
            {{ translator("reset-password-success-title") }}
          </h2>
          <p class="form-subtitle" style="margin-bottom: 2rem">
            {{ translator("reset-password-success-text") }}
          </p>
        </div>
      } @else {
        <!-- Form State -->
        <div class="fade-in">
          <div class="form-header">
            <h2 class="form-title">
              {{ translator("password-reset-title") }}
            </h2>
            <p class="form-subtitle">
              {{ translator("reset-password-condition-text") }}
            </p>
          </div>

          <!-- User Provided Form Structure -->

          <abc-text-box
            #emailTextBox
            [(value)]="resetEmail"
            [stylingMode]="'outlined'"
            [width]="'100%'"
            (valueChange)="updateField()"
            [label]="translator('Ubt-CreateStaffMembers-EMail')"
            [labelMode]="'floating'"
          >
            <dx-validator>
              <dxi-validation-rule
                type="email"
                message="Please enter a valid email address"
              ></dxi-validation-rule>
              <dxi-validation-rule
                type="required"
                message="{{ translator('Ubt-validator-RequiredField') }}"
              ></dxi-validation-rule>
            </dx-validator>
          </abc-text-box>

          <abc-button
            class="button-password"
            text="E-Mail senden"
            type="default"
            (onClick)="submitResetEmail()"
            [disabled]="!isValidEmail()"
          ></abc-button>
          <p class="contact-support">
            {{ translator("password-contact-support-note") }}
            <a href="" class="contact-support-btn">
              <strong class="support-style">{{
                translator("password-support-text")
              }}</strong></a
            >
          </p>
          <a routerLink="/login" class="back-link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m12 19-7-7 7-7" />
              <path d="M19 12H5" />
            </svg>
            {{ translator("back-to-login") }}
          </a>
        </div>
      }
    </div>
  </div>
</div>
